import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { Apollo, Mutation } from 'apollo-angular';


export class CreateAwardCriteriaInput {
    individual: number;
    team: number;
    numberOfPoints: number;
}


export type CreateAwardCriteriaMutationVariables = {
    input: {
        individual: number;
        team: number;
        numberOfPoints: number;
    };
};

export type CreateAwardCriteriaMutation = {
    createAwardCriteria: {
        id: string;
    };
};


export const CreateAwardCriteriaDocument = gql`
  mutation CreateAwardCriteria($input: CreateAwardCriteriaDto!) {
  createAwardCriteria(data: $input) {
    id
  }
}
`;

@Injectable({
    providedIn: 'root',
})
export class CreateAwardCriteriaGQL extends Mutation<
    CreateAwardCriteriaMutation,
    CreateAwardCriteriaMutationVariables
> {
    document = CreateAwardCriteriaDocument;

    constructor(apollo: Apollo) {
        super(apollo);
    }
}
